// Vendoers
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
// Components
import ImagePlaceholder from 'Components/ImagePlaceholder'
import { NoPaddingCol } from 'Components/EnhacedFlexboxGrid'
import SvgIcon from 'Components/SvgIcon'
// Styles
import { _PlaceHolderImageHolder, _HeroContainer, _BgHeroImage,
  _SliderHolder, _HeroImageContainer, _Counter } from './styles'

// Static Variables
const imgPlaceholderSrc = '/static/images/building_placeholder_1600x1068.jpg'


class BuildingHero extends Component {
  constructor(props) {
    super(props)

    this.renderHero = this.renderHero.bind(this)
  }

  renderHero(photos) {
    const { building } = this.props
    // Without building show placeholder
    if(!(building && building.photos && Array.isArray(building.photos))) {
      return (
        <_SliderHolder>
          <_PlaceHolderImageHolder
            key={imgPlaceholderSrc}
          >
            <ImagePlaceholder
              src={imgPlaceholderSrc}
              defaultSrc={imgPlaceholderSrc}
              alt={''}
            />
          </_PlaceHolderImageHolder>
        </_SliderHolder>
      )
    }
    const title = building.name
    const photoCount = building.photos ? R.length(building.photos) : 0
    return (
      <div key={title + photoCount}>
        { photoCount ? (
          <_HeroImageContainer>
            <_BgHeroImage>
              <ImagePlaceholder
                src={photos?.[0]?.img || photos?.[0]?.originImg}
                alt={`${title} hero image`}
              />
              <_Counter>
                <SvgIcon name={'#icon-photos'} width={14} height={14} />
                +{photoCount || 1}
              </_Counter>
            </_BgHeroImage>
          </_HeroImageContainer>
        ) : (
          <_BgHeroImage as={NoPaddingCol}>
            <ImagePlaceholder
              src={''}
              alt={`${title} coming soon photo`}
            />
          </_BgHeroImage>
        )
        }
      </div>
    )
  }
  render() {
    const {
      photos,
      gaSource,
    } = this.props
    return (
      <_HeroContainer
        onClick={() => {
          this.props.openPhotosAndLocation()
          this.props.googleAnalyticsEvent({
            category: gaSource || 'building',
            action: '[App][Hero Image Clicked]',
          })
        }}
      >
        {this.renderHero(photos)}
      </_HeroContainer>
    )
  }
}

BuildingHero.propTypes = {
  building: PropTypes.shape({
    name: PropTypes.string,
    photos: PropTypes.arrayOf(PropTypes.shape({})),
    primary_address: PropTypes.shape({
      title: PropTypes.string,
    }),
    medias: PropTypes.oneOfType([
      PropTypes.shape({
        Youtube: PropTypes.shape({
          thumbnail: PropTypes.string,
          media_id: PropTypes.string,
        }),
        Matterport: PropTypes.shape({}),
        MPEmbed: PropTypes.shape({}),
      }),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
    address: PropTypes.shape({}),
  }),
  googleAnalyticsEvent: PropTypes.func,
  photos: PropTypes.arrayOf(PropTypes.shape({})),
  openPhotosAndLocation: PropTypes.func,
  gaSource: PropTypes.string,
}


export default BuildingHero
